import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import $ from 'jquery';

const GLOBAL = require('../../Globals');

class AssignSubject extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			_message : '',
			alertClass :'',
			id : '',
			acyear : '',
			cls : '',
			subject : '',
			section : '',
			posts : [],
			secs : [],
			accyear : [],
			subj : [],
			_redirect : false
		}
		this.handleInputChange = this.handleInputChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onBack = this.onBack.bind(this);
	}
	
	handleInputChange(e){
		
		this.setState({[e.target.name]:e.target.value});
		// console.log(this.state);
	}
	
	onBack(e){
		
		this.setState({_redirect : true});
		
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.acyear && this.state.cls && this.state.section && this.state.subject){
			console.log(this.state);
			PostData('assignsubject/updatesub',this.state).then((result) => {
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Assign Subject Updated Successfullly',
						alertClass:'alert alert-success'
					});	
					document.getElementById("assubform").reset();
				}
				else{
			
					this.setState({
						_message:'Already Added',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getacyear();
		this.getclass();
		this.getsection();
		this.getsubject();
		this.getdetails();
	}
	
	getacyear(){
		
		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
			}
		});
	}
	
	/** get Class **/
	getclass(){
		
		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	/** get Section **/
	getsection(){
		
		GetData('section/getsection').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					secs : responseJson
				});
			}
		});
	}
	
	/** get Class **/
	getsubject(){
		
		GetData('subject/getsub').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					subj : responseJson
				});
			}
		});
	}
	
	getdetails(){
		
		GetData('assignsubject/getsubbyid/'+this.props.match.params.id).then((result) => {
			let res = result;
			if(res){
				this.setState({
					acyear : res[0]['acyear'],
					cls : res[0]['class'],
					section : res[0]['section'],
					subject : res[0]['subject']
				});
			}
		});
	}
	
  render() {
	  
	this.state.id = this.props.match.params.id;
	  var items = this.state.posts;
	  var sec = this.state.secs;
	  var sub = this.state.subj;
	  var acyear = this.state.accyear;
	
	if(this.state._redirect){
		  
		return (<Redirect to='/subject/assignsubject' />);
	}
	
	/** get Section By Class **/
	$("#clas").change(function(){
		var fr = $(this).val();
		var ar = $("#year").val();
		$.get(GLOBAL.BASE_URL+'section/getsecbyclass/'+ar+'/'+fr,function(o){
			//$("#acHead").removeClass('chosen_a');
			$("#secs").html('');
			$('#secs')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Section- ')); 
			$.each(o,function(key,value){			
				   $('#secs')
					.append($("<option></option>")
					.attr("value",value.id)
					.text(value.secs)); 	
										
			});	
			//	$("#acHead").addClass('chosen_a');
			
		},'json');
	
	});
	
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
			<Row>
			  <Col md="12">
				<Card>
				  <form action="" method="post" role="form" id="subform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Edit Assign Subject</strong>
						<span className="pull-right">
							<Button outline color="primary" onClick={this.onBack}>Back</Button>
						</span>
					</CardHeader>
					<CardBody>
						<Row>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Academic Year <span className="text-danger">*</span></Label>
							  <select name="acyear" className="form-control" onChange={this.onChange} required id="year" value={this.state.acyear}>
								<option value="">Select</option>
								{
									acyear.map(function (item) {
										return <option value={item.id }>{item.value}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Class <span className="text-danger">*</span></Label>
							  <select name="cls" onChange={this.handleInputChange} className="form-control" id="clas" required value={this.state.cls} > 
								<option value="">Select Class</option>
								{
									items.map(function (item) {
										return <option value={item.id }>{item.class}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Section <span className="text-danger">*</span></Label>
							  <select name="section" onChange={this.handleInputChange} className="form-control" id="secs" required value={this.state.section} >
								<option value="">Select Section</option>
								{
									sec.map(function (item) {
										return <option value={item.id }>{item.section}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Subject <span className="text-danger">*</span></Label>
							  <select name="subject" onChange={this.handleInputChange} className="form-control" required value={this.state.subject} >
								<option value="">Select Subject</option>
								{
									sub.map(function (item) {
										return <option value={item.id }>{item.subject}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						</Row>
					</CardBody>
					<CardFooter>
						<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
					</CardFooter>
				  </form>
				</Card>
			  </Col>
			</Row>
		</div>
	)
  }
}

export default AssignSubject;


// WEBPACK FOOTER //
// ./src/subject/AssignSubject/EditAssignSubject.js